<template>

    <div  v-wechat-title="$route.meta.title='报名参与活动'">
        <div :style="background"></div>
        <div class="button1">
              <img  class="trailer" src="../../assets/images/trailer.png">
              <img v-if="info.subscribe==0" @click.stop="subscribe(1,info.id)" class="subscribe" src="../../assets/images/subscribe.png">
              <img v-if="info.subscribe==1" @click.stop="subscribe(0,info.id)" class="subscribe" src="../../assets/images/unsubscribe.png">
        </div>      
         <div class="news_r1" >
                
                <p class="content">
                  <label>{{info.title}}</label>
                  <div class="contentImg" :style="{width:width+'px',height:height+'px',margin:'8px'}">
                    <div class="activity" v-lazy:background-image="info.img">
                    </div>
                    <div class="livedetailtime" v-lazy:background-image="require('../../assets/images/livedetailtime.png')">
                      {{info.showTime}}
                    </div>
                    <div class="downtime">
                      <p >倒计时</p>
                      <label v-if="endTime<=0">{{content}}</label>
                      <label v-else>
                         
                            {{day}}<a style="font-size:1rem">天</a>
                            {{hour}}<a style="font-size:1rem">小时</a></a>
                            {{min}}<a style="font-size:1rem">分</a></a>
                            {{sec}}<a style="font-size:1rem">秒</a></a>
                        
                      </label>
                       <p >
                         {{timestres}}
                      </p>
                    </div>
                  </div>                  
                </p>
          </div>
          <van-popup class="van-popup" :close-on-click-overlay="false" v-model="popupShow">
            <div v-if="isSubscribe" :class="popupmsg" style="margin-top: 2rem">
               <van-image
                  v-if="subscribeType==1"
                  width="5rem"
                  :src="require('../../assets/images/success.png')"
                />
                <label style="font-weight:600;font-size:1rem;display:block;margin: 1rem;">{{message}}</label>
                 <van-button @click="close"   class="close" >我知道了</van-button> 
              </div>
             <div class="is-subscribe" v-else>
                <div class="text">
                   您还不是莱美官方服务号的粉丝，无法收到订阅提醒。请扫描下方二维码，或者微信搜索 <span>"莱美爱好者"</span>，关注后获取接收订阅通知~
                </div>
                <van-image
                  width="10rem"
                  :src="require('../../assets/images/qcode.jpg')"
                />
                 <van-button @click="close"   class="close1" >我知道了</van-button> 
             </div> 
           </van-popup>
    </div>
</template>

<script>
import { getLiveDetail,subscribe} from '@/api/api.js'
import { parseTime } from '@/utils/utils.js'
export default {
  
    data(){
        return{
           id:0,
           background: {
              backgroundImage:'url(' + require('../../assets/images/liveback.png') + ')',
              backgroundRepeat:"no-repeat",
              backgroundSize:"100% 100%",
              width: "100%",
              height: "100%",
              position:'fixed',
              zIndex: -10,
              top:0
             },
             info:[],
             width:'320',
             height:"180",
              popupShow:false,
              subscribeType:1,
              isSubscribe:0,
              message:'',
              popupmsg:'popup-msg',
              button:true,
              endTime:'',
              content:'',
              day:0,
              hour:0,
              min:0,
              sec:0,
              timestres:''         
        }
    },
     computed: {
      
        
    },
    created(){
        
    },
    updated() {
         
    },
     mounted () {
       this.getParams();
       this.getinfo();
        window.screenWidth = document.body.clientWidth
         this.width = window.screenWidth-20;//设置视频长宽比
         this.height = this.width*(9/16);
         this.countdowm()
         this.startTime()
    },
    methods:{
         getinfo(){
          // 异步更新数据
                let parame = {id:this.id};
                getLiveDetail(parame).then((res)=>{
                    if(res.code==200){
                      this.info = res.result;
                      this.endTime = res.result.start_time
                       
                    } 
                   //Toast('提示内容') 
                }),(err)=>{
                    console.log(err);
                }
         },
          getParams() {
            this.id = this.$route.query.id;
        },
        //返回上一页
        onClickLeft(){
            this.$router.go(-1)
        },
        confirm(){
            if(this.pickertime){
              this.push_time = this.pickertime
            }
            this.picker = false;
        },
       
         //订阅和取消订阅
      subscribe(type,id){
        if(this.button){
           this.button = false
           let parame = {'status':type,'id':id};
                subscribe(parame).then((res)=>{
                    if(res.code==200){
                        if(res.result['type']=='subscribe'){
                            this.info.subscribe = 1;
                            this.subscribeType = 1
                            this.popupmsg = 'popup-msg'
                        }else{
                           this.info.subscribe = 0;
                            this.subscribeType = 0
                            this.popupmsg = 'popup-msg1'
                        }
                        this.isSubscribe = res.result['isSubscribe']
                        this.message = res.message
                        this.button = true
                        this.popupShow = true
                    } 
                   //Toast('提示内容')
                  //console.log(this.list);  
                }),(err)=>{
                    console.log(err);
                     this.button = true
                }
        }
      },
      close(){
            this.popupShow = false
      },
      //倒计时回调
     countdowm(){
            let self = this;
            let timer = setInterval(function(){
                let nowTime = new Date();
                let endTime = self.endTime * 1000;
               
                let t = endTime - nowTime.getTime();
               
                if(t>0){
                    let dayer = Math.floor(t/86400000);
                    let hourer=Math.floor((t/3600000)%24);
                    let miner=Math.floor((t/60000)%60);
                    let secer=Math.floor((t/1000)%60);
                    self.day = dayer;
                    self.hour = hourer;
                    self.min = miner;
                    self.sec = secer;
                   
                  }else{
                      clearInterval(timer);
                      self.content = "已结束";
                       console.log(t,self.endTime);
                     
                  }
                 },1000);
               },
          startTime(){
           let self = this;
            setInterval(function(){
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minutes = date.getMinutes();
                let second = date.getSeconds();
                self.timestres =  self.check(hour)
                  + ":" + self.check(minutes) + ":" + self.check(second);
                  
              },1000)


        },
      check(val) {
        if (val < 10) {
          return ("0" + val);
        } 
        else {
          return (val);
        }
      },

    },
    
    watch: {
        
    }

}
</script>
 
<style scoped>
  .downtime>p{
    font-size: 1rem;
    font-weight: 600;
    color: #dec887;
    margin: .5rem;
    letter-spacing:.1rem;
  }
.downtime>label{
    font-size: 1rem;
    font-weight: 600;
    color: #dec887;
    margin: .5rem;
    letter-spacing:.1rem;
  }
  .livedetailtime{
      width: 13rem;
      height: 3rem;
      background-size: 100%;
      background-repeat: no-repeat;
      margin: auto;
      margin-top: 2rem;
      color: #fff;
      line-height: 4rem;
  }
  .demo-lazyload {
      box-sizing: border-box;
      height: 200px;
      margin: 10px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.close{
    margin:auto;
    color:#000;
    width: 70%;
    background-color:#ffc425;
    border: none;
    margin-bottom: 1.5rem;
    font-weight:600;
  }
  .van-popup{
    border-radius: .5rem;
  }
  .is-subscribe{
     width:18rem;
     height:24rem;
     top:45%;
     color:#000;

  }
  .is-subscribe>.text{
    padding: 1rem;
    text-align: left;
    padding: 1rem;
    text-align: left;
    letter-spacing: .01rem;
    font-size: 0.9rem;

  }
  .popup-msg{
    width:16rem;
    height:13rem;
    top:45%;
    color:#000;
  }
  .popup-msg1{
    width: 16rem;
    height: 7rem;
    top:45%;
    color:#000;
  }
  .activity{
   height: 100%;
    width: 100%;
    background-color: white;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position:relative;
    margin-bottom: .6rem;
}
  .contentImg{
     box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
     border: #616161 solid 2px;
    border-radius: 3px;
  }
  .news_r1>p>label{
  
    display: block;
    letter-spacing:.1rem;
    color:#fff;
    font-weight: 600;
    font-size: 1rem;
}
  .button1:after{
      content:".";        
     display:block;        
     height:0;        
     clear:both;        
     visibility:hidden;        
  }
  .news_r1>.content{
    margin-top:0.5rem;
  }
 .subscribe{
    width: 4rem;
    float: right;
    margin: 1.5rem;
}
.trailer{
   width: 2.5rem;
    float: left;
    margin: 2rem;
}
.close1{
    width:9rem;
    margin:auto;
    color:#000;
    background-color:#ffc425;
    border: none;
    margin-bottom: 1.5rem;
    font-weight:600;
}

</style>